import React, { useState, useEffect } from 'react';
import { translate } from '../../../Services/translation';

const FMGFormBlock = (props) => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        phoneNumber: '',
        email: '',
        projectName: '',
        homepageLink: '',
        description: '',
        document: null,
    });
    const [formError, setFormError] = useState('');
    const [fileName, setFileName] = useState('');
    const [loading, setLoading] = useState(true);
    const [showConfirmation, setShowConfirmation] = useState(false);

    useEffect(() => {
        if (props.result && props.result.length > 0) {
            setLoading(false); 
        }
    }, [props.result]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const allowedTypes = [
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/pdf',
                'application/vnd.ms-powerpoint',
                'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            ];
            if (allowedTypes.includes(file.type)) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    document: file,
                }));
                setFileName(file.name);
                setFormError('');
            } else {
                setFormError(translate('fmg-form-error-invalid-doc-type'));
            }
        }
    };

    const handleImageClick = () => {
        document.getElementById('fileInput').click();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let isFormValid = validateForm();
        if (isFormValid) {
            let senderEmail = '';
            let receiverEmail = '';
            if (props.result && props.result.length > 0) {
                senderEmail = props.result[0].senderEmail;
                receiverEmail = props.result[0].receiverEmail;
            }
            let formDataToSend = new FormData();
            formDataToSend.append('SenderEmail', senderEmail);
            formDataToSend.append('ReceiverEmail', receiverEmail);
            formDataToSend.append('FirstName', formData.firstName);
            formDataToSend.append('LastName', formData.lastName);
            formDataToSend.append('PhoneNumber', formData.phoneNumber);
            formDataToSend.append('Email', formData.email);
            formDataToSend.append('ProjectName', formData.projectName);
            formDataToSend.append('HomepageLink', formData.homepageLink);
            formDataToSend.append('Description', formData.description);
            formDataToSend.append('Document', formData.document);
            try {
                const response = await fetch('/api/fmgFormBlock/sendEmail', {
                    method: 'POST',
                    body: formDataToSend,
                    referrerPolicy: "no-referrer",
                    mode: "cors",
                    headers: {
                        "litium-request-context": JSON.stringify(window.__litium.requestContext)
                    },
                });

                if (response.ok) {
                    setShowConfirmation(true);
                } else {
                    console.error('Failed to upload file');
                }
            } catch (error) {
                console.error('Error:', error);
            }
        }
    };

    const validateForm = () => {
        if (!formData.firstName.trim()) {
            setFormError(translate('fmg-form-error-first-name-required'));
            return false;
        } else if (!formData.lastName.trim()) {
            setFormError(translate('fmg-form-error-last-name-required'));
            return false;
        } else if (!formData.phoneNumber.trim()) {
            setFormError(translate('fmg-form-error-phone-number-required'));
            return false;
        } else if (!/^[\d-]+$/.test(formData.phoneNumber)) {
            setFormError(translate('fmg-form-error-phone-number-invalid'));
            return false;
        } else if (!formData.email.trim()) {
            setFormError(translate('fmg-form-error-email-required'));
            return false;
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            setFormError(translate('fmg-form-error-email-invalid'));
            return false;
        } else if (!formData.projectName.trim()) {
            setFormError(translate('fmg-form-error-project-name-required'));
            return false;
        } else if (
            formData.homepageLink.trim() &&
            !/^https?:\/\/\S+$/.test(formData.homepageLink)
        ) {
            setFormError(translate('fmg-form-error-homepage-link-invalid'));
            return false;
        } else if (!formData.description.trim()) {
            setFormError(translate('fmg-form-error-description-required'));
            return false;
        } else if (!formData.document) {
            setFormError(translate('fmg-form-error-document-required'));
            return false;
        }
        setFormError('');
        return true;
    };

    const block = props.result.find((x) => x.blockId === props.blockId);
    return !loading && block && !showConfirmation ? (
        <div className='FMGForm-Block grid-system grid-system-within-boundaries'>
            <div className='grid-full-width'>
                <h3 className='FMGForm-Block__text'>{block.blockText}</h3>
                <div className='FMGForm-Block__profile'>
                    <div className='FMGForm-Block__profile__image-container'>
                        <img src={block.profileImage.url} alt="prof-pic"></img>
                    </div>
                    <div className='FMGForm-Block__profile__info-container'>
                        <p className='FMGForm-Block__profile__info-container__name'>{block.profileName}</p>
                        <p className='FMGForm-Block__profile__info-container__role'>{block.profilePosition}</p>
                    </div>
                </div>
                <form className='FMGForm-Block__form' onSubmit={handleSubmit}>
                    {formError && <p className='FMGForm-Block__form__error'>{formError}</p>}
                    <div className="FMGForm-Block__form__row">
                        <div className='FMGForm-Block__form__first-name'>
                            <p className='FMGForm-Block__form__label'>{translate('fmg-form-first-name')}</p>
                            <input
                                type="text"
                                className='FMGForm-Block__form__input'
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleChange}
                                placeholder={translate('fmg-form-first-name-placeholder')}
                            />
                        </div>
                        <div className='FMGForm-Block__form__last-name'>
                            <p className='FMGForm-Block__form__label'>{translate('fmg-form-last-name')}</p>
                            <input
                                type="text"
                                className='FMGForm-Block__form__input'
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleChange}
                                placeholder={translate('fmg-form-last-name-placeholder')}
                            />
                        </div>
                    </div>
                    <div className="FMGForm-Block__form__row">
                        <div className='FMGForm-Block__form__phone-number'>
                            <p className='FMGForm-Block__form__label'>{translate('fmg-form-phone-number')}</p>
                            <input
                                type="text"
                                className='FMGForm-Block__form__input'
                                name="phoneNumber"
                                value={formData.phoneNumber}
                                onChange={handleChange}
                                placeholder={translate('fmg-form-phone-number-placeholder')}
                            />
                        </div>
                        <div className='FMGForm-Block__form__email'>
                            <p className='FMGForm-Block__form__label'>{translate('fmg-form-email')}</p>
                            <input
                                type="text"
                                className='FMGForm-Block__form__input'
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder={translate('fmg-form-email-placeholder')}
                            />
                        </div>
                    </div>
                    <div className="FMGForm-Block__form__row">
                        <div className='FMGForm-Block__form__project'>
                            <p className='FMGForm-Block__form__label'>{translate('fmg-form-project-name')}</p>
                            <input
                                type="text"
                                className='FMGForm-Block__form__input'
                                name="projectName"
                                value={formData.projectName}
                                onChange={handleChange}
                                placeholder={translate('fmg-form-project-name-placeholder')}
                            />
                        </div>
                        <div className='FMGForm-Block__form__homepage'>
                            <p className='FMGForm-Block__form__label'>{translate('fmg-form-homepage-link')}</p>
                            <input
                                type="text"
                                className='FMGForm-Block__form__input'
                                name="homepageLink"
                                value={formData.homepageLink}
                                onChange={handleChange}
                                placeholder={translate('fmg-form-homepage-link-placeholder')}
                            />
                        </div>
                    </div>
                    <div className='FMGForm-Block__form__description FMGForm-Block__form__row'>
                        <p className='FMGForm-Block__form__label'>{translate('fmg-form-homepage-description')}</p>
                        <textarea
                            type="text"
                            className='FMGForm-Block__form__input'
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            placeholder={translate('fmg-form-homepage-description-placeholder')}
                        />
                    </div>
                    <div className="FMGForm-Block__form__row">
                        <div className="FMGForm-Block__form__doc">
                            <div>
                                <span onClick={handleImageClick} />
                                <p onClick={handleImageClick}>{translate('fmg-form-document')}</p>
                            </div>
                            <input
                                type="file"
                                id="fileInput"
                                accept=".doc,.docx,.xls,.xlsx,.pdf,.ppt,.pptx"
                                onChange={handleFileChange}
                                style={{ display: 'none' }}
                            />
                            {fileName && <p>{fileName}</p>}
                        </div>
                        <button type="submit">{translate('fmg-form-confirm-button')}</button>
                    </div>
                </form>
            </div>
        </div>
    ) : (
            <div className='FMGForm-confirmation grid-system grid-system-within-boundaries'>
                <div className='FMGForm-confirmation__message grid-full-width'>
                    <span></span>
                    <h3>{translate("fmg-form-confirm.SuccessMessage")}</h3>
                    <p>{translate("fmg-form-confirm.SuccessMessage.SubTitel")}</p>
                </div>
        </div>
    );
};

export default FMGFormBlock;
